import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CommonTitleBar from "../../../components/common/CommonTitleBar";
import MeetingRoomsCard from "./MeetingRoomsCard";
import NoDataFound from "components/common/NoDataFound";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllWorkspaces } from "store/actions/workspaceSlice";
import Paginations from "components/common/Paginations";
import Spinners from "components/common/Spinners";
import SpaceShimmer from "components/ShimmerEffects/SpaceShimmer";

const MeetingRooms = () => {
  const { t } = useTranslation();
  document.title = t("Meeting Rooms | Work Space");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const pageNumber = Number(new URLSearchParams(search).get("page")) || 1;

  const {
    isLoading,
    loading,
    workspaces: meetingRooms,
    drafts,
    perPage,
    totalCount,
    totalPages,
    currentPage,
  } = useSelector((state) => state.Workspace);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = (page) => {
    const payload = {
      spaceTypeInt: 2, // Space Type Int [1-workSpace , 2-meetingRoom , 3-workShop]
      perPage: perPage,
      pageNo: page || pageNumber,
      status: -1,
      orderBy: -1,
      keyword: "",
      dateRange: {},
    };
    dispatch(getAllWorkspaces(payload));
    navigate(`/bookings/meeting-rooms?page=${page || pageNumber}`);
  };

  return (
    <React.Fragment>
      <div className="page-content meeting_rooms_page common_page">
        <Container fluid>
          <CommonTitleBar
            title={t("Meeting Rooms")}
            isCreateBtn={true}
            createBtnText={t("Add New")}
            onCreateBtnClick={() => navigate("/bookings/meeting-rooms/add-new")}
          />
          <div className="common_wrapper">
            <Row>
              {loading ? (
                <SpaceShimmer col={4} />
              ) : meetingRooms?.length === 0 ? (
                <NoDataFound />
              ) : (
                meetingRooms?.map((item) => (
                  <MeetingRoomsCard
                    key={item?.id}
                    item={item}
                    isLoading={isLoading}
                  />
                ))
              )}
            </Row>
          </div>
          <h2 className="main_title">{t("Draft")}</h2>
          <div className="common_wrapper">
            {loading ? (
              <SpaceShimmer col={4} />
            ) : drafts?.length === 0 ? (
              <NoDataFound text={t("No drafts saved yet")} />
            ) : (
              <Row>
                {drafts?.map((item) => (
                  <MeetingRoomsCard
                    key={item?.id}
                    item={item}
                    className="draft"
                    isLoading={isLoading}
                  />
                ))}
              </Row>
            )}
          </div>
          {!loading && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MeetingRooms;
